<template>
  <div class="articleMain">
    <div class="centerMain">
      <h3 class="h3_title">{{ formData.theme }}</h3>
      <div class="info">
        <span>发布部门：{{ formData.publishingDepartment }}</span>
        <!--<span>阅读量：{{ formData.browseTimes }}</span>-->
        <span>{{ formData.releaseTime.substring(0, 10) }}</span>
      </div>
      <video
        v-if="videoUrl"
        class="video"
        :src="videoUrl"
        controls="controls"
      ></video>
      <viewer v-if="!isApp" :images="[]">
        <div class="contain" v-html="formData.content"></div>
      </viewer>
      <div v-else class="contain" v-html="formData.content"></div>
      <div class="bottom">
        <!-- <h3>来源：{{ formData.ptSource }}</h3>
        <span v-if="formData.reporter">记者：{{ formData.reporter }}</span>
        <span v-if="formData.photography">
          摄影：{{ formData.photography }}
        </span> -->
        <span v-if="formData.photography && formData.reporter">
          <span v-if="formData.photography === formData.reporter">
            供稿：{{ formData.photography }}
          </span>
          <span v-else>
            供稿：{{ formData.photography }} {{ formData.reporter }}
          </span>
        </span>
        <span v-else>
          <span v-if="formData.reporter"> 供稿：{{ formData.reporter }}</span>
          <span v-if="formData.photography">
            供稿：{{ formData.photography }}
          </span>
        </span>
        <span v-if="formData.publishingName">
          编辑：{{ formData.publishingName }}
        </span>
        <span v-if="formData.firstName">责编：{{ formData.firstName }}</span>
        <span v-if="formData.secondName">
          编审：{{ formData.secondName }}
        </span>
      </div>
      <div class="erweima">
        <h1>点击图中二维码下载“红城发布APP”</h1>
        <p>随时随地获取身边咨询，轻轻松松开启红城生活</p>
        <div id="apk" @click="getApk">
          <img :src="ewmImg" />
        </div>
      </div>
      <div class="comments clearfix">
        <div>
          <span class="bottom_left">精彩评论（{{ replyList.length }}）</span>
          <el-button class="bottom_right right" size="mini" @click="getApk">
            <i class="el-icon-download"></i>APP下载
          </el-button>
        </div>
        <div>
          <ul class="ul_main">
            <li
              class="list_item"
              v-for="(item, index) in replyList"
              :key="index"
            >
              <p class="clearfix">
                <img
                  class="photo left"
                  :src="item.imgUrl"
                  onerror="this.src='./imgs/portal/default_img.png'; this.onerror=null"
                />
                <span class="name">{{ item.replyName }}</span>
                <span class="time">{{ item.createTime.substring(0, 10) }}</span>
                <a class="like right" @click="likeFun(item)">
                  <img
                    class="like_img left"
                    v-if="item.alreadyLiked === true"
                    src="../../../../public/imgs/home/dianzan_active.png"
                  />
                  <img
                    class="like_img left"
                    v-else
                    src="../../../../public/imgs/home/dianzan.png"
                  />
                  点赞{{ item.clickCount }}
                </a>
              </p>
              <p class="list_content">{{ item.content }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import apiList from "@/views/partybuild/api/partyApiList.js";
import commonApi from "@/api/commonApi";
import { myBrowser } from "@/assets/js/com";
function setFormObj() {
  return {
    theme: "",
    userName: "",
    isExternalLink: "",
    source: "",
    publishingDepartment: "",
    browseTimes: "",
    releaseTime: "",
    content: "",
    ptSource: "",
    reporter: "",
    publishingName: "",
    photography: "",
    firstName: "",
    secondName: "",
    timestamp: "",
    nonceStr: "",
    signature: ""
  };
}
export default {
  data() {
    return {
      isApp: false,
      formData: setFormObj(),
      ewmImg: "./imgs/home/apkImg1.png",
      apkUrl: "",
      replyList: [],
      fileData: {
        bizId: "",
        submittedFileName: "",
        url: ""
      },
      videoUrl: ""
    };
  },
  created() {},
  mounted() {
    const vm = this;
    const width = document.documentElement.offsetWidth;
    const height = document.documentElement.offsetHeight;
    //alert(width + "," + height * 0.67);
    if (width < height * 0.67) {
      document.getElementsByClassName("articleMain")[0].style.maxWidth =
        width + "px";
    }
    commonApi
      .wxSign({ url: window.location.href })
      .then(res => {
        if (res.data) {
          vm.timestamp = res.data.timestamp;
          vm.nonceStr = res.data.noncestr;
          vm.signature = res.data.signature;
        }
        vm.toExamineDetail();
      })
      .catch(() => {
        vm.toExamineDetail();
      });
    /*window.$("#apk").on("touchstart", function(e) {
      e.preventDefault();
      vm.getApk();
    });
    window.$("#apk").on("touchend", function(e) {
      e.preventDefault();
      vm.fileDownload();
    });*/
    window.setIsApp = vm.setIsApp();
  },
  methods: {
    setIsApp() {
      this.isApp = true;
    },
    goback() {
      const vm = this;
      vm.$router.go(-2);
    },
    // 获取详情
    async toExamineDetail() {
      const vm = this;
      //let searchId = window.location.search.slice(4);
      //let searchId = "702174678805918625";
      let str = window.location.search;
      let idStr = str.split("&")[0];
      let idAry = idStr.split("=");
      let searchId = idAry[1];
      // vm.getAttachment(searchId);
      const res = await apiList.appNewDetail(searchId);
      if (res.data.code === 0) {
        vm.formData = res.data.data;
        if (
          window.navigator.userAgent.toLowerCase().indexOf("micromessenger") >
          -1
        ) {
          vm.weixinFun();
        }
        vm.getReplyList();
        vm.videoUrl = res.data.data.videoUrl;
        vm.$nextTick(() => {
          const list = document.getElementsByTagName("img");
          for (let item of list) {
            item.addEventListener("click", function() {
              window.imagelistener.openImage(item.src);
            });
          }
        });
      } else {
        vm.formData = setFormObj();
        vm.$message.error(res.data.msg);
      }
    },
    // 设置微信分享
    weixinFun() {
      const vm = this;
      const shareTitle = vm.formData.theme;
      const shareDesc = vm.formData.description;
      const shareLink = window.location.href;
      const shareImgUrl = vm.formData.imgUrl;
      wx.config({
        debug: false,
        appId: "wx8886e31ff426740f",
        timestamp: vm.timestamp,
        nonceStr: vm.nonceStr,
        signature: vm.signature, // JSSDK 1.4.0以上版本
        // jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone'],
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"]
      });

      wx.ready(function() {
        //分享给朋友、QQ
        wx.updateAppMessageShareData({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImgUrl,
          success: function() {},
          fail: function() {}
        });
        //分享到朋友圈
        wx.updateTimelineShareData({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImgUrl,
          success: function() {},
          fail: function() {}
        });
      });
    },
    // 查询附件
    async getAttachment(searchId) {
      const vm = this;
      const res = await commonApi.getAttachment({
        bizIds: searchId,
        bizTypes: "POST_VIDEO"
      });
      if (res.status === 200) {
        if (res.data.code === 0) {
          if (res.data.data.length > 0) {
            let data = res.data.data[0].list;
            vm.videoUrl = data[0].url;
          }
        }
      }
    },
    // 获取安装包bizId
    async getApk() {
      const vm = this;
      const res = await apiList.clientVersionGetLatest();
      if (res.data.code === 0) {
        if (res.data.data) {
          vm.fileData.bizId = res.data.data.attachmentDTO.id;
          vm.fileData.submittedFileName =
            res.data.data.attachmentDTO.submittedFileName;
          vm.fileData.url = res.data.data.attachmentDTO.url;
          vm.fileDownload();
        }
      } else {
        vm.$message.error(res.data.msg);
      }
    },
    // 附件下载
    async fileDownload() {
      const vm = this;
      const res = await commonApi.downloadAttachment({
        ids: [vm.fileData.bizId]
      });
      if (res.status === 200) {
        if (res.data) {
          let blob = new Blob([res.data]);
          if (myBrowser() === "IE" || myBrowser() === "Edge") {
            window.navigator.msSaveOrOpenBlob(
              blob,
              vm.fileData.submittedFileName
            );
            return false;
          }
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          if (
            myBrowser() === "Safari" ||
            window.navigator.userAgent.toLowerCase().indexOf("micromessenger") >
              -1
          ) {
            link.href = vm.fileData.url;
          }
          link.download = vm.fileData.submittedFileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        } else {
          vm.$message.error("下载错误，请重试或联系管理员");
        }
      }
    },
    // 获取回复列表
    async getReplyList() {
      const vm = this;
      const res = await apiList.articleReplyPage({
        data: { pid: vm.formData.id, queryType: 2 },
        pageNo: 1,
        pageSize: 20
      });
      if (res.data.code === 0) {
        vm.replyList = res.data.data.records;
      }
    },
    // 点赞
    async likeFun(item) {
      const vm = this;
      const res = await apiList.postRecord({
        bizId: item.id,
        type: {
          code: "LIKED"
        }
      });
      if (res.data.code === 0) {
        vm.getReplyList();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.articleMain {
  height: 100%;
  max-width: 67vh;
  // max-width: 500px;
  margin: 0 auto;
  position: relative;
  background: #fff;
  .centerMain {
    padding: 15px 10px;
  }
  .h3_title {
    margin-bottom: 10px;
    font-size: 16px;
  }
  .info {
    display: flex;
    display: -webkit-flex; /* Safari */
    justify-content: space-between;
    padding: 10px;
    font-size: 12px;
    background: #f8f8f8;
  }
  .bottom {
    padding: 15px 0;
    border-bottom: 1px dashed;
    text-align: right;
    span {
      width: 100%;
      display: inline-block;
    }
  }
  .erweima {
    text-align: center;
    margin-top: 10px;
    img {
      width: 100%;
      height: auto;
    }
    p {
      margin: 10px 0;
    }
    #apk {
      cursor: pointer;
    }
  }
  .comments {
    .left {
      float: left;
    }
    .right {
      float: right;
    }
    margin: 25px 0 10px;
    .bottom_left {
      font-size: 16px;
      border-left: 5px solid #f0222c;
      padding-left: 5px;
    }
    .bottom_right {
      font-size: 16px;
      margin-right: 5vw;
    }
    ul.ul_main {
      padding: 0;
      list-style: none;
      display: block;
      margin: 15px auto;
      width: auto;
      .list_item {
        .name {
          display: block;
        }
        .time {
          color: #999;
        }
        .photo {
          width: 40px;
          height: 40px;
          margin-right: 8px;
          border-radius: 50%;
        }
        .like {
          .like_img {
            width: 15px;
          }
        }
        .list_content {
          margin: 5px 0 10px 48px;
        }
      }
    }
  }
}
.video {
  width: 100%;
}
</style>
